
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sell-clothes-online",
      function () {
        return require("private-next-pages/sell-clothes-online/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sell-clothes-online"])
      });
    }
  